import { useDebouncedEffect } from '@react-hookz/web/esm/useDebouncedEffect';
import { useEffect, useState } from "react";
import FormGroup from "./FormGroup";
import Button from '../components/Button';


const PageTitle = (props) => {
    const { pageTitleTemplate, pageTitleTemplateConfig, refreshPreview } = props;
    
    const [title, setTitle] = useState(pageTitleTemplate);
    useEffect(() => setTitle(pageTitleTemplate), [pageTitleTemplate]); // I don't understand why this is needed to get the default value to update

    useDebouncedEffect(() => refreshPreview('pageTitleTemplate', title), [title], 500);

    return <FormGroup labelKey="pageTitleTemplate" label="Page Title Template">
        <div className='inline-flex items-center'>
            <input id="pageTitleTemplate" type="text" className="w-9/12 m-1 border py-2 px-3 text-grey-darkest" value={title} onChange={event => setTitle(event.target.value)} />
            <Button variant="secondary" label="Use Default" onClick={() => setTitle(pageTitleTemplateConfig.defaultTemplate) } className="inline-flex items-center px-1 mx-2" />
        </div>
        <div className='my-2 text-xs text-gray-600'><span>Default Template:</span><span>{pageTitleTemplateConfig.defaultTemplate}</span></div>
        <div>Valid Variables: {pageTitleTemplateConfig.variables.map(variable => <Button key={variable} variant="secondary" label={variable} onClick={() => setTitle(title + variable) } className="inline-flex items-center px-1 mx-2" />)}</div>
    </FormGroup>
};

export default PageTitle;